import { Text } from "@chakra-ui/react";

export default function Overline2({ children, ...rest }) {
  return (
    <Text fontWeight={500} fontSize="1rem" lineHeight="1.2" {...rest}>
      {children}
    </Text>
  );
}
